var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { get } from "lodash";
import withAuth from "@irati/auth/helpers/auth/withAuth";
import { injectIntl } from "@irati/utils/lang";
import Wallet from "./Wallet";
var Wallets = /** @class */ (function (_super) {
    __extends(Wallets, _super);
    function Wallets() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Wallets.prototype.render = function () {
        var _a = this.props, formatMessage = _a.formatMessage, auth = _a.auth;
        var productPermissions = auth.productPermissions, business = auth.business;
        var tenantName = business.businessName;
        var canManageTenantWallet = get(productPermissions, "wallet.tenantWallet");
        var showRewardWallet = get(productPermissions, "wallet.rewardWallet");
        var showUserWallet = get(productPermissions, "wallet.users");
        return (React.createElement(React.Fragment, null,
            canManageTenantWallet && (React.createElement(React.Fragment, null,
                React.createElement(Wallet, { title: tenantName, route: "tenant", walletType: "TENANT", availableBalanceTooltip: "admin.reportingV2.wallet.tenantTransactions.balance1.tooltip" }),
                showRewardWallet && (React.createElement(Wallet, { title: formatMessage({ id: "admin.reportingV2.wallet.rewardTransactions.wallet" }), route: "reward", walletType: "MANAGER", availableBalanceTooltip: "admin.reportingV2.wallet.rewardTransactions.balance.tooltip" })))),
            showUserWallet && (React.createElement(Wallet, { title: formatMessage({ id: "admin.reportingV2.wallet.peopleTransactions.wallet" }), route: "people", walletType: "USER", availableBalanceTooltip: "admin.reportingV2.wallet.peopleTransactions.balance.tooltip" }))));
    };
    return Wallets;
}(PureComponent));
export default injectIntl(withAuth(Wallets));
